export const PUBLIC_URL = process.env.PUBLIC_URL;
export const IS_DEV = process.env.REACT_APP_ENV === "development";
export const IS_XAGENT = process.env.REACT_APP_ENV === "xagent";
export const ENV = process.env.REACT_APP_ENV;

console.log("PUBLIC_URL", PUBLIC_URL);
console.log("REACT_APP_IS_XAGENT", process.env.REACT_APP_IS_XAGENT);
console.log("NODE_ENV", process.env.NODE_ENV);
